var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = x({ ["a"]: () => __WEBPACK_EXTERNAL_MODULE_yargs_helpers_7b1be1d4__.hideBin });